import { AreaUnit } from '../enums/AreaUnit';

const areaUnitMapping: Record<AreaUnit, string> = {
    [AreaUnit.UNKNOWN]: '',
    [AreaUnit.METER]: 'м²',
    [AreaUnit.ARE]: 'сот.',
    [AreaUnit.HECTARE]: 'гектар'
};

export { areaUnitMapping };
